module.exports = __webpack_public_path__ + "img/share_top1_bg.b2d1ebd6.webp";